import Button from "@material-ui/core/esm/Button";
import React from 'react';
export default function TabButton({
  children,
  onClick,
  className
}) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    color: "primary",
    onClick: onClick,
    className: className
  }, children);
}